@if (isVisible()) {
  <div class="generation-notification" [class.has-toast-offset]="offsetForUpdateToast()">
    <div class="notification-header">
      <span class="spinner" aria-hidden="true"></span>
      <span class="notification-title">Generating your playbook &amp; ICP</span>
      <button type="button" class="notification-close" (click)="hide()" aria-label="Hide generation progress">
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </div>

    <div class="progress-row">
      <div
        class="progress-bar"
        role="progressbar"
        aria-label="Playbook and ICP generation progress"
        [attr.aria-valuenow]="progressPercent()"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <div class="progress-fill" [style.width.%]="progressPercent()"></div>
      </div>
      <span class="progress-text">{{ progressPercent() }}%</span>
    </div>

    <p class="notification-caption" aria-live="polite">{{ caption() }}</p>
  </div>
}

@if (isFailureVisible()) {
  <div class="generation-notification" [class.has-toast-offset]="offsetForUpdateToast()">
    <div class="notification-header">
      <i class="pi pi-exclamation-circle failure-icon" aria-hidden="true"></i>
      <span class="notification-title">Website import failed</span>
      <button type="button" class="notification-close" (click)="hideFailure()" aria-label="Hide import failure">
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </div>

    <p class="notification-caption">{{ failureHeadline() }}</p>
    <button type="button" class="notification-action" (click)="showFailure()">Fix the address</button>
  </div>
}
